module.exports = __webpack_public_path__ + "5e88fabc00fd2623293ab481bb9baea9.png";